.accordionContainer,
.accordionHeader,
.accordionHeaderTitle,
.accordionColumnTitle,
.controlEnvironmentEffectivenessContainer,
.accordionHeaderContainer {
    display: flex;
    align-items: center;
}

.scoreFactors,
.lastUpdatedInfo,
.additionalInfo,
.titleAndCategory {
    display: flex;
    flex-direction: column;
}

.scoreInfo {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.scoreFactors {
    display: flex;
    flex-direction: column;
    gap: 3px; /* Half of the padding of the button link for showing the number of controls mapped. This ensures horizontal alignment of the multiple lines in this "row". */
}

.additionalInfo {
    padding-top: 20px;
    padding-left: 36px;
    padding-bottom: 18px;
    padding-right: 5px;
    gap: 20px;
}

.additionalInfoRowsContainer {
    display: flex;
    margin-left: -31px; /* additional info's padding-left of 36px - accordion container's padding of 5px */
}

.accordionHeaderContainer {
    width: 100%;
    margin-top: 20px;
    padding: 5px;
    border-radius: 9px;
    background-color: rgba(5, 60, 89, 0.06);
}

.evenlySpacedAccordionItemsContainer {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.accordionContainer {
    padding: 5px;
}

.accordionHeader,
.accordionColumn {
    width: 14%;
    flex: 1;
    margin-left: 20px;
}

.accordionColumn {
    overflow-wrap: anywhere;
}

.accordionHeaderTitle,
.accordionColumnTitle {
    width: 30%;
}

.accordionHeaderTitle {
    padding-left: 36px;
}

.controlEnvironmentEffectivenessContainer {
    gap: 5px;
}

.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}

.title {
    display: flex;
    max-width: 175px;
    word-break: break-all;
}